var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("layout-5", {
        staticStyle: { height: "calc(100vh - 95px)" },
        attrs: {
          id: _vm.pageid,
          term: _vm.term,
          is_document: false,
          path: "pictures/pic_",
          empty: "No Pictures"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nav-bar" }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.addPicture()
              }
            }
          },
          [_vm._v("Add Picture")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.deletePicture()
              }
            }
          },
          [_vm._v("Delete Picture")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74be12d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74be12d3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Job_Orders_Pictures.vue
// module id = 532
// module chunks = 0